import React, { useEffect } from 'react';
import {
    Container,
    Typography,  
    Card,
    CardContent,
    List,
    ListItem,
    ListItemText,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { TextField } from '@mui/material';

interface Miembro {
    rol: string;
    nombre: string;
}

interface ComisionDirectiva {
    ejecutivos: Miembro[];
    vocalesTitulares: string[];
    vocalesSuplentes: string[];
    revisores: string[];
}

const comision: ComisionDirectiva = {
    ejecutivos: [
        { rol: 'Presidente', nombre: 'Fernando Aguilar' },
        { rol: 'Vicepresidente', nombre: 'Luis Medina' },
        { rol: 'Tesorero', nombre: 'Enzo Velázquez' },
        { rol: 'Secretario', nombre: 'Fernando Alurralde' },
        { rol: 'Pro Secretario', nombre: 'Yonatan Ponce' },
        { rol: 'Pro Tesorero', nombre: 'Esteban Pavón' },
        
    ],
    vocalesTitulares: [
        'Fernando Juan',
        'Miguel Sierra',
        'Esteban Pavón',
        'Víctor Miani',
        'Deolinda Gramajo',
    ],
    vocalesSuplentes: [
        'Ramiro Adanto',
        'Jorge López',
        'Baby Ochoa',
        'Julio Barrionuevo',
        'Claudia Ocampo',
    ],
    revisores: ['Sebastián Morales', 'Daniel Herrera'],
    };


export const ComisionDirectiva: React.FC = () => {
    useEffect(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' }); // O 'auto' si no querés animación
}, []);
    return (
        <Container maxWidth="md" sx={{ mt: 4, mb: 4 }} style={{backgroundImage:'linear-gradient(145deg, rgba(23, 150, 97, 1),rgba(10, 166, 227, 1))'}}>
            <div>
                <div>
                    <img src={'img/logo.png'} className="d-inline-block align-top logo" alt="Logo" />
                </div>
                <div>
                    <Typography variant="h4" align="center" gutterBottom color="textSecondary">
                        Club Social y Deportivo Atlécito Famailla
                    </Typography>
                </div>                
            </div>
            <Typography variant="h4" align="center" gutterBottom color="textSecondary">
                Comisión Directiva
            </Typography>

            <Grid container spacing={1}>
                <Grid size={{ xs: 12, md: 6}}>
                    <Card elevation={3} style={{height:'670px'}}>
                        <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Ejecutivos
                        </Typography>
                        <List dense>
                            {comision.ejecutivos.map((miembro, index) => (
                            <ListItem key={index}>
                                <ListItemText
                                primary={miembro.nombre}
                                secondary={miembro.rol}
                                />
                            </ListItem>
                            ))}
                        </List>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid size={{ xs: 12, md: 6}}>
                <Card elevation={3}>
                    <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Vocales Titulares
                    </Typography>
                    <List dense>
                        {comision.vocalesTitulares.map((nombre, index) => (
                        <ListItem key={index}>
                            <ListItemText primary={nombre} />
                        </ListItem>
                        ))}
                    </List>

                    <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                        Vocales Suplentes
                    </Typography>
                    <List dense>
                        {comision.vocalesSuplentes.map((nombre, index) => (
                        <ListItem key={index}>
                            <ListItemText primary={nombre} />
                        </ListItem>
                        ))}
                    </List>

                    <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                        Revisores de Cuentas
                    </Typography>
                    <List dense>
                        {comision.revisores.map((nombre, index) => (
                        <ListItem key={index}>
                            <ListItemText primary={nombre} />
                        </ListItem>
                        ))}
                    </List>
                    </CardContent>
                </Card>
                </Grid>
            </Grid>

            <Typography
                variant="subtitle1"
                align="center"
                sx={{ mt: 4, fontWeight: 'bold', color: 'TextField' }}
            >
                Lista: El Fama Somos Todos
            </Typography>
        </Container>
    );
};
